import { CanHistoryMessages, TranslationCanHistoryMessages } from "../interfaces/canHistoryMessages";

const canHistoryMessages: TranslationCanHistoryMessages = {
  [CanHistoryMessages.title]: "Historial CAN",
  [CanHistoryMessages.dateTime]: "Fecha/Hora",
  [CanHistoryMessages.fleet]: "Flota",
  [CanHistoryMessages.plate]: "Matrícula",
  [CanHistoryMessages.travelDoc]: "Factura",
  [CanHistoryMessages.status]: "Estado",
  [CanHistoryMessages.driver]: "Conductor",
  [CanHistoryMessages.ignition]: "Ignición",
  [CanHistoryMessages.ignitionOn]: "Encendida",
  [CanHistoryMessages.ignitionOff]: "Apagada",
  [CanHistoryMessages.odometer]: "Odómetro",
  [CanHistoryMessages.totalFuel]: "Combustible Total",
  [CanHistoryMessages.speed]: "Velocidad",
  [CanHistoryMessages.rpm]: "RPM",
  [CanHistoryMessages.coolantTemp]: "Temp. Refrigerante",
  [CanHistoryMessages.fuelConsumption]: "Consumo de Combustible",
  [CanHistoryMessages.fuelLevel]: "Nivel de Combustible",
  [CanHistoryMessages.hourmeter]: "Horómetro",
  [CanHistoryMessages.totalDrivingTime]: "Tiempo Total de Conducción",
  [CanHistoryMessages.idleFuel]: "Combustible Inactivo",
  [CanHistoryMessages.address]: "Dirección",
  [CanHistoryMessages.rawDataTooltip]: "Dato bruto del rastreador (sin normalización CAN)"
};

export const messages = canHistoryMessages;
